export default "__VITE_ASSET__Cgpn1pdv__"